<div class="container">
  <div class="header">
    <pdq-heading element="h3">{{ isEdit ? 'Edit' : 'Add' }} recipe</pdq-heading>
    <pdq-button
      [disabled]="isLoading"
      (onClick)="onClose()"
      iconColor="var(--on-surface-light)"
      variant="ghost"
      icon="close"></pdq-button>
  </div>
  <div class="wrapper">
    <div class="content">
      <div class="recipe-template-formula">
        @for (element of recipeElements; track element; let i = $index) {
          @if (!isVariable(element)) {
            @if (isIntegrationName(element)) {
              <div>
                <strong>{{ element }}</strong>
              </div>
            } @else {
              <div>{{ element }}</div>
            }
          } @else {
            @switch (getVariable(element)?.type) {
              @case (InputType.MULTI_SELECT) {
                <dropdown-variable
                  (onVariableChange)="handleVariableChange($event)"
                  [variable]="getVariable(element)"></dropdown-variable>
              }
              @case (InputType.SELECT) {
                <dropdown-variable
                  [variable]="getVariable(element)"
                  (onVariableChange)="handleVariableChange($event)"></dropdown-variable>
              }
            }
          }
          <ng-template #variable>
            @switch (getVariable(element)?.type) {
              @case (InputType.MULTI_SELECT) {
                <dropdown-variable
                  (onVariableChange)="handleVariableChange($event)"
                  [variable]="getVariable(element)"></dropdown-variable>
              }
              @case (InputType.SELECT) {
                <dropdown-variable
                  [variable]="getVariable(element)"
                  (onVariableChange)="handleVariableChange($event)"></dropdown-variable>
              }
            }
          </ng-template>
        }
      </div>
    </div>
  </div>
  <footer>
    <pdq-button [disabled]="isLoading" label="Cancel" (onClick)="onClose()"></pdq-button>
    <pdq-button
      [disabled]="!variablesValid"
      (onClick)="onAdd()"
      [loading]="isLoading"
      variant="primary"
      [label]="isEdit ? 'Save' : 'Add'"></pdq-button>
  </footer>
</div>
